export default "__VITE_ASSET__wQiRYdmo__"